const { commonConfig } = require('@alfa-bank/assr-common-config');
const { dataLayerListener } = require('./src/counters/data-layer.cjs');
const { cdnPlugin } = require('@plotva/assr-core-plugins');
const { name, version, dependencies } = require('./package.json');
const { dependencies: privateDependencies } = require('./src/private/package.json');
const { dependencies: sideTeamDependencies } = require('./src/side-team/package.json');
const { gtm, gtmNoScript, getGTMId } = require('./src/counters/gtm.cjs');
const {
    ytm,
    ytmNoScript,
    ytmCookie,
    ytmSendUserParams,
    ytmSendEvent
} = require('./src/counters/ytm.cjs');
const { platformIdReady } = require('./src/counters/platform-id-ready.cjs');
const { antiFraud, alfaPartners } = require('./src/counters/partners.cjs');

const config = {
    ...commonConfig,
    postcss: {
        customPropertiesFile: 'node_modules/@alfalab/core-components/themes/site.css'
    },
    cssHashLen: 5,
    widgetsContexts: ['@alfa-bank', '@plotva'],
    additionalWidgetPackages: ['@plotva/common-widgets'],
    instanceName: name,
    instanceVersion: version,
    getDependencies: () => ({ ...dependencies, ...sideTeamDependencies, ...privateDependencies }),
    getCounters: (url, data) => {
        const { CUSTOM_YTM_ID, ENABLE_COUNTERS } = process.env;
        const {
            collectorData: { host }
        } = data;
        const gtmId = getGTMId(host);
        const isCountersEnabled = ENABLE_COUNTERS === 'true';
        const enableYtm = isCountersEnabled && CUSTOM_YTM_ID;
        const ytmScripts = [
            ytmNoScript,
            ytmCookie,
            dataLayerListener,
            ytmSendUserParams,
            ytmSendEvent
        ];
        const headGTM = isCountersEnabled ? gtm(gtmId) : '';
        const headYTM = enableYtm ? ytm(url) : '';
        const bodyYTM = enableYtm ? ytmScripts.join('') : '';

        return {
            headCounters: [platformIdReady, headGTM, headYTM],
            bodyCounters: [
                gtmNoScript(gtmId),
                bodyYTM,
                isCountersEnabled ? alfaPartners(url) : '',
                isCountersEnabled ? antiFraud : ''
            ],
            endBodyCounters: []
        };
    },
    cdnReplacement: {
        enabled: false,
        viewLog: false
    },
    plugins: [
        {
            plugin: cdnPlugin,

            config: {
                cdnPublicPath: process.env.CDN_PUBLIC_PATH,
                domainPattern: '(https?:)?//alfabank[.]st'
            }
        }
    ]
};

module.exports = config;
